import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EyefinityDashboardStatusTypeEnum } from '../eyefinity-dashboard/eyefinity-dashboard-status-type.enum';
import {
  DASHBOARD_ERROR_URL,
  EYEFINITY_URL,
  MANAGEMENT_URL,
  PENDING_URL,
} from '@share/constants';
import { SignupStatusService } from '../data-services/signup-status/signup-status.service';
import { NGXLogger } from 'ngx-logger';

@Injectable()
export class StatusGuard {
  private router = inject(Router);
  private statusService = inject(SignupStatusService);
  private logger = inject(NGXLogger);

  canActivate(
    _next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.determineSignupStatus();
  }

  determineSignupStatus(): Observable<boolean> {
    return this.statusService.checkForEyefinityDashboardStatus$().pipe(
      map((value) => {
        switch (value) {
          case EyefinityDashboardStatusTypeEnum.newSignup: {
            return true;
          }
          case EyefinityDashboardStatusTypeEnum.pendingSignup: {
            this.router.navigate([EYEFINITY_URL + PENDING_URL]);
            return false;
          }
          case EyefinityDashboardStatusTypeEnum.omiManage: {
            this.router.navigate([EYEFINITY_URL + MANAGEMENT_URL]);
            return false;
          }
          default: {
            this.router.navigate([DASHBOARD_ERROR_URL]);
            return false;
          }
        }
      }), // TODO log to server when this exists
      catchError((err) => {
        const errMsg =
          "An error occurred while trying to determine the practice's signup status. " +
          err;
        this.logger.error(errMsg);
        this.router.navigate([DASHBOARD_ERROR_URL]);
        return of(false);
      }),
    );
  }
}
